// DNS-derived email security posture signals from `client_enrichment.dns`.
// SPF / DMARC / DKIM presence and policy strength directly drive BEC and
// phishing probability. Universal across all profiles.
//
// Output: weight adjustments + evidence strings the advisor can quote.

export function detectDnsSecurityPosture(dns = {}) {
  const adj = { attackVectors: {}, threatActors: {} }
  const evidence = []
  const findings = []

  const hasSPF = !!dns.hasSPF
  const hasDMARC = !!dns.hasDMARC
  const dmarcPolicy = (dns.dmarcPolicy || '').toLowerCase()
  const hasDKIM = !!dns.hasDKIM

  // SPF — without it, anyone can spoof the domain
  if (!hasSPF) {
    adj.attackVectors.business_email_compromise = (adj.attackVectors.business_email_compromise || 0) + 0.20
    adj.attackVectors.phishing = (adj.attackVectors.phishing || 0) + 0.15
    findings.push('No SPF record — domain is trivially spoofable')
  }

  // DMARC enforcement is the single biggest BEC defense indicator
  if (!hasDMARC) {
    adj.attackVectors.business_email_compromise = (adj.attackVectors.business_email_compromise || 0) + 0.25
    adj.threatActors.bec_groups = (adj.threatActors.bec_groups || 0) + 0.20
    findings.push('No DMARC record — receivers have no instruction to reject unauthenticated mail purporting to be from this domain')
  } else if (dmarcPolicy === 'none' || dmarcPolicy === '') {
    adj.attackVectors.business_email_compromise = (adj.attackVectors.business_email_compromise || 0) + 0.15
    adj.threatActors.bec_groups = (adj.threatActors.bec_groups || 0) + 0.10
    findings.push('DMARC policy is p=none (monitoring only) — spoofed mail still delivers')
  } else if (dmarcPolicy === 'quarantine') {
    adj.attackVectors.business_email_compromise = (adj.attackVectors.business_email_compromise || 0) + 0.05
    findings.push('DMARC p=quarantine — partial protection, spoofed mail lands in spam rather than being rejected')
  }
  // p=reject means strong posture, no adjustment

  // DKIM
  if (!hasDKIM) {
    adj.attackVectors.business_email_compromise = (adj.attackVectors.business_email_compromise || 0) + 0.05
    findings.push('No DKIM signing detected — outbound messages cannot be cryptographically validated by recipients')
  }

  if (findings.length === 0) {
    evidence.push('Email authentication posture is strong (SPF, DMARC enforcement, DKIM all present) — reduces BEC probability')
  } else {
    evidence.push(...findings.map(f => `Email auth gap: ${f}`))
  }

  return { adjustments: adj, evidence, findings }
}
